class Account
{

   static  countdowm(_this, phone, second) {
        if (phone) {
            var num = second;
            let timer = setInterval(function () {
                if (num == 1) {
                    _this.second = second;
                    _this.disabled = false;
                    clearInterval(timer);
                    _this.downText = "发送验证码";
                } else {
                    _this.disabled = true;
                    num--;
                    _this.downText = num + "秒后重新发送";
                }
            }, 1000);
        } else {
            _this.downText = "未绑定手机号";
            _this.disabled = true;
        }
    }
}

export default Account;


// WEBPACK FOOTER //
// ./src/tools/account.js